import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CheckboxSetting from '../settings/CheckboxSetting';
import { Form, Row } from 'react-bootstrap';
import { AllowedDocumentTypes, DocumentViewerFieldModel } from '../../../../../../models/form/fields/documentViewer';
import SelectSetting from '../settings/SelectSetting';
import ColorSetting from '../settings/ColorSetting';
import { updateSelectedField, selectedFieldSelector } from '../../../../../../slices/formadmin';
import CultureTextSetting from '../settings/CultureTextSetting';
import { RootState } from '../../../../../../store';

const DocumentViewerProperties: FC = () => {
  const field = useSelector(selectedFieldSelector) as DocumentViewerFieldModel;
  const selectedLanguage = useSelector((state: RootState) => state.formAdmin.selectedLanguage) as string;
  const dispatch = useDispatch();

  return (
    <Form>
      <Row className="align-items-center">
        <CultureTextSetting
          id={`field.${field.id}.text`}
          culture={selectedLanguage}
          value={field.text}
          label="adminProperties.fields.common.text"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                text: val,
              }),
            )
          }
        />
        <ColorSetting
          value={field.textColor}
          label="adminProperties.fields.common.textColor"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                textColor: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'hiddenText'}
          checked={field.hiddenText}
          label="adminProperties.fields.common.hiddenText"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                hiddenText: val,
              }),
            )
          }
        />
        <CheckboxSetting
          id={field.id + 'visible'}
          checked={field.visible}
          label="adminProperties.fields.common.visible"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                visible: val,
              }),
            )
          }
        />
        <CultureTextSetting
          id={`field.${field.id}.defaultValue`}
          culture={selectedLanguage}
          value={field.defaultValue}
          label="adminProperties.fields.documentViewer.defaultValue"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                defaultValue: val,
              }),
            )
          }
        />
        <CultureTextSetting
          id={`field.${field.id}.documentName`}
          culture={selectedLanguage}
          value={field.documentName}
          label="adminProperties.fields.documentViewer.documentName"
          size={12}
          onChange={(val) =>
            dispatch(
              updateSelectedField({
                ...field,
                documentName: val,
              }),
            )
          }
        />
        <SelectSetting
          noEmptyValue={true}
          options={[
            { text: 'PDF', value: 'pdf' },
            { text: 'Excel (XLSX)', value: 'xlsx' },
            { text: 'Excel (XLS)', value: 'xls' },
            { text: 'Word (DOCX)', value: 'docx' },
            { text: 'Word (DOC)', value: 'doc' },
          ]}
          label="adminProperties.fields.documentViewer.documentType"
          size={12}
          value={field.documentType}
          onChange={(val) => {
            dispatch(
              updateSelectedField({
                ...field,
                documentType: val as AllowedDocumentTypes,
              }),
            );
          }}
        />
      </Row>
    </Form>
  );
};

export default DocumentViewerProperties;
